var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 18,
  viewBox: "0 0 18 18",
  width: 18,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.73 13.852h9.176c.545 0 1.014-.2 1.405-.598a1.94 1.94 0 0 0 .587-1.406V3.094c0-.539-.196-1.008-.587-1.406a1.904 1.904 0 0 0-1.405-.598H3.094c-.545 0-1.014.2-1.405.598-.39.398-.587.867-.587 1.406v12.938zM16.093.914A3.03 3.03 0 0 1 17 3.13v8.683c0 .868-.302 1.606-.907 2.215a2.967 2.967 0 0 1-2.187.914H5.014L0 18V3.129C0 2.262.302 1.524.907.914A2.972 2.972 0 0 1 3.094 0h10.812c.854 0 1.583.305 2.187.914z",
  fill: "currentColor",
  fillRule: "evenodd"
})));
export default SvgIconComment;